<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Ingresos hoy</span>
  
  </mat-toolbar>
  
  <div class="margin-container apearAnimation">
    <!-- <app-tableusr></app-tableusr> -->

    <div
    fxLayout="row wrap"
    fxLayout.xs="column"
    fxLayoutAlign.xs="space-around stretch"
    fxLayoutAlign.md="space-between center"
    fxLayoutAlign="space-around stretch"
    fxLayoutGap="5px"
    class="stats-cards apearAnimation"
    >
        <mat-card fxFlex="25" fxFlex.sm="100" fxFlex.md="95" fxFlex.lg="25" fxFlex.xl="25">
            <mat-card-content>
                <div fxLayout="row" fxLayoutAlign="center">
                    <h1>Logo del club</h1>
                </div>
    
                <br/>
    
                <div fxFill fxLayout="column" fxLayoutAlign="center center">
                    <img mat-card-image 
                        class="foto-perfil"
                        [src]="fotoPerfil"
                    >
                </div>
    
                <br/>
    
                <div fxLayout="row" fxLayoutAlign="center">
                    <button  type="button" mat-raised-button  (click)="fileInput1.click()" color="warn">Actualizar logo</button>
                      <input
                        hidden
                        #fileInput1
                        type="file"
                        accept="image/png, image/jpeg"
                        id="file1"
                        (change)="showPreviewImage($event)"
                      />
    
                </div>
            </mat-card-content>
        </mat-card>
    
        <mat-card fxFlex="70" fxFlex.sm="100" fxFlex.md="95" fxFlex.lg="70" fxFlex.xl="70">
            <mat-card-content class="dashboard-card-content">
                
                <div fxLayout="row" fxLayoutAlign="center">
                    <h1>Datos Básicos</h1>
                </div>
    
                <br/>
    
                <form [formGroup]="perfilFormGroup">
                    <div class="form-container"   fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="center">
                      
                        <mat-form-field appearance="outline" fxFlex="25" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="25" fxFlex.xl="25">
                          <mat-label>Razón Social</mat-label>
                          <input matInput maxlength="100" formControlName="razonSocial" required>
                        </mat-form-field>
          
                        <mat-form-field appearance="outline" fxFlex="25" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="25" fxFlex.xl="25">
                          <mat-label>Dirección</mat-label>
                          <input matInput  formControlName="direccion">
                        </mat-form-field>
                   
                        
                        <mat-form-field appearance="outline" fxFlex="25" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="25" fxFlex.xl="25">
                            <mat-label>Teléfono</mat-label>
                            <input matInput  formControlName="telefono">
                          </mat-form-field>
                          
                          <mat-form-field appearance="outline" fxFlex="25" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="25" fxFlex.xl="25">
                            <mat-label>Celular</mat-label>
                            <input matInput  formControlName="celular" required>
                          </mat-form-field>
                          
                          <mat-form-field appearance="outline" fxFlex="25" fxFlex.sm="100" fxFlex.md="45" fxFlex.lg="25" fxFlex.xl="25">
                            <mat-label>Email</mat-label>
                            <input matInput  formControlName="email" required>
                          </mat-form-field>

                    </div>
        
    
                </form>
    
                <br/>
    
                <div fxLayout="row" fxLayoutAlign="center">
                    <button mat-raised-button color="primary" [disabled]="perfilFormGroup.invalid" (click)='actualizarEmpresa()'>Guardar Cambios</button>
                </div>
            </mat-card-content>
        </mat-card>
    

    </div>

  

  </div>
  